export default "__VITE_ASSET__BcSaVnST__"